import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';

import * as PodcastConstants from '../../../../constants';
import * as D from '../../../../deps';
import BackstagePodcastEpisodeList from '../../../common/BackstagePodcastEpisodeList';

import './BackstagePodcastProgramRecentEpisodesContent.scss';

const BackstagePodcastProgramRecentEpisodesContent = props => {
  const { recentEpisodes, totalEpisodeCount } = props;

  if (totalEpisodeCount === null) {
    return (
      <div className='BackstagePodcastProgramRecentEpisodesContent__loading'>
        <D.Loading isRowList={true} />
      </div>
    );
  } else if (totalEpisodeCount > 0) {
    const numPlaceholders = Math.min(
      totalEpisodeCount,
      PodcastConstants.PODCAST_RECENT_EPISODE_MAX_LIST_SIZE,
    );
    return (
      <BackstagePodcastEpisodeList episodes={recentEpisodes} numPlaceholders={numPlaceholders} />
    );
  }

  return null;
};

BackstagePodcastProgramRecentEpisodesContent.propTypes = {
  recentEpisodes: ImmutablePropTypes.listOf(PropTypes.string),
  totalEpisodeCount: PropTypes.number,
};

export default BackstagePodcastProgramRecentEpisodesContent;
